import React from 'react';
import styled from 'styled-components';
import { Headline, Caption1, Subhead } from '../../../../components/Typography';
import appConfig from '../../../../../app-config';
import { useTranslation } from 'react-i18next';

const BalanceWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-gap: 15px;
  margin: auto 0;
`;

const InternalLoyaltyCardBalanceWrapper = ({
  balance,
  nextOfferProgress,
  nextOfferTitle,
  layoutStyle,
}) => {
  const { t } = useTranslation();
  return (
    <BalanceWrapper>
      <div>
        <Caption1
          style={{ fontWeight: '600' }}
          color={appConfig.styleConfig.loyaltyCardTextColour}
        >
          {t('rewards.yourBalance')}:
        </Caption1>
        <Headline
          color={appConfig.styleConfig.loyaltyCardTextColour}
          id='LoyaltyCard-PointsHeadline'
        >
          {balance} {t('rewards.points')}
        </Headline>
      </div>
      {nextOfferProgress !== null ? (
        <div>
          <Caption1
            style={{ fontWeight: '600' }}
            color={appConfig.styleConfig.loyaltyCardTextColour}
          >
            {nextOfferProgress}% {t('rewards.percentToNextReward')}
          </Caption1>
          <Subhead
            style={{ color: appConfig.styleConfig.loyaltyCardTextColour }}
            id='LoyaltyCard-PointsSubhead'
          >
            {layoutStyle === 'offer'
              ? nextOfferTitle
              : nextOfferTitle.substring(0, 15) + '...'}
          </Subhead>
        </div>
      ) : (
        <div>
          <Caption1
            style={{ fontWeight: '600' }}
            color={appConfig.styleConfig.loyaltyCardTextColour}
          >
            {t('rewards.allRewardsUnlocked')}
          </Caption1>
        </div>
      )}
    </BalanceWrapper>
  );
};

export default InternalLoyaltyCardBalanceWrapper;
